<div class="user-admin-container">
  <mat-tab-group>
    <!-- User Management Tab -->
    <mat-tab label="User Management">
      <div class="tab-content">
        <!-- Placeholder for user form, dropdowns, etc. -->
        <h2>User Management</h2>
        <app-user-management-table></app-user-management-table>
      </div>
    </mat-tab>

    <mat-tab label="Active Users">
      <div class="tab-content">
        <h2>Active Users</h2>
        <p>Below is a list of all currently active users.</p>
        <app-active-users-table></app-active-users-table>
      </div>
    </mat-tab>

    <!-- System Account Tab -->
    <mat-tab label="System Account">
      <div class="tab-content">
        <!-- Placeholder for data grid, table, or list -->
        <h2>System Account</h2>
        <div class="component">
          <div class="component-header">System Account</div>
          <div class="component-content">
            <form [formGroup]="form" (ngSubmit)="onSaveSystemAccountDco()">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Select DCO</mat-label>
                <mat-select [formControl]="systemAccountDCOFormControl">
                  <mat-option *ngFor="let dco of activeDcos" [value]="dco">{{ dco.name }}</mat-option>
                </mat-select>
                <mat-error *ngIf="systemAccountDCOFormControl.hasError('required')">
                  DCO is required
                </mat-error>
              </mat-form-field>

              <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Save</button>
            </form>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
